import axj_web_mutaions from "./axj-web/mutaions"
import common_mutations from "./common/mutations"
import axj_help_mutations from "./axj_help/mutaions"
export default {
  ...axj_web_mutaions,
  ...common_mutations,
  ...axj_help_mutations
}



// WEBPACK FOOTER //
// ./src/store/mutations.js